<template>
  <div class="markdown_wrapper">
    <el-button icon="el-icon-edit" @click="drawer = true">录入</el-button>

    <el-drawer
      :with-header="false"
      title="MarkDown编辑器"
      :visible.sync="drawer"
      :direction="direction"
      size="100%"
      :before-close="handleClose"
      :destroy-on-close ="true"
    >
      <mavon-editor
        ref="md"
        class="mavon-editor"
        v-model="value"
        :toolbars="toolbars"
        :ishljs="true"
        :navigation="false"
        :toolbarsFlag="true"
        @save="SaveMarkdown"
        @imgAdd="imgAdd"
        @imgDel="imgDel"
        :toolbarsBackground="'white'"
        :placeholder="'开始编辑...按ESC键退出...'"
        :tabSize="4"
        
      ></mavon-editor>
    </el-drawer>
  </div>
</template>

<script>
import uploadFileBlob from "@/config/uploadFileBlob";
import { dateFormatName } from "@/config/_filter";

export default {
  name: "markdown",
  props:{
    markdown:String
  },
  data() {
    return {
      value: "",
      drawer: false,
      direction: "rtl",

      //图片上传
      uploadFileTime: false,

      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      Editor_Height: "",
    };
  },

  mounted() {

    this.Editor_Height = "800px";
    this.value = this.markdown;
    console.log(this.value)
    console.log(this.markdown)

    console.log('MARKDOWN传值')

  },
  methods: {
    SaveMarkdown(val, render) {
      console.log("保存markdown");
      console.log(val);
      console.log(render);

      this.$emit("SaveMarkDown", val,render);
      this.$message.success('已保存!')
      this.drawer = false;

    },
    SaveHtmlCode(val, render) {
      console.log("保存htmlcode");
      console.log(val);
      console.log(render);
    },

    imgAdd(pos, file) {
      console.log(pos);
      console.log(file);
      console.log(file.miniurl.split(",")[1]);

      var that = this;
      uploadFileBlob(
        Buffer.from(file.miniurl.split(",")[1], "base64"),
        "static/markdown/images/" + dateFormatName() + ".png",
        function (res) {
          console.log("上传成功");
          console.log(res);

          if (res.url) {
            that.$refs.md.$img2Url(pos, res.url);

            console.log(res.url);
          } else {
            that.$message.warning("上传失败");
          }
        }
      );
    },
    imgDel() {},

    uploadFileBlob() {},

    handleClose(done) {
      this.$confirm("记得保存文档哦!")
        .then((res) => {
          console.log(res);
          done();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.markdown_wrapper {
  width: 100%;
  height: 100%;
  .mavon-editor {
    height: 100vh;
  }
}
</style>
